module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "vision"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('em', [_vm._v("Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To your tired eyes I bring a vision"), _c('br'), _vm._v("of a different world,"), _c('br'), _vm._v("so new and clean and fresh"), _c('br'), _vm._v("you will forget the pain and sorrow"), _c('br'), _vm._v("that you saw before."), _c('br'), _vm._v("Yet this is a vision"), _c('br'), _vm._v("which you must share"), _c('br'), _vm._v("with everyone you see,"), _c('br'), _vm._v("for otherwise you will behold it not."), _c('br'), _vm._v("To give this gift is how to make it yours.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—From "), _c('em', [_vm._v("A Course in Miracles")]), _vm._v(" by Helen Cohn Schucman"), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e0e146","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/vision.vue
// module id = 75
// module chunks = 0